"use strict";

exports.__esModule = true;
exports.saveForumDisplayState = saveForumDisplayState;
exports.getForumDisplayState = getForumDisplayState;
exports.FORUM_DISPLAY_STATE = void 0;
var FORUM_DISPLAY_STATE = 'forum-display-state';
exports.FORUM_DISPLAY_STATE = FORUM_DISPLAY_STATE;

function saveForumDisplayState(value) {
  typeof sessionStorage !== 'undefined' && sessionStorage.setItem && sessionStorage.setItem(FORUM_DISPLAY_STATE, value);
}

function getForumDisplayState() {
  return typeof sessionStorage !== 'undefined' && sessionStorage.getItem && sessionStorage.getItem(FORUM_DISPLAY_STATE);
}